export default __webpack_public_path__ + "static/ios-logo-2-80eebf1efca819ac816ba0346e1925f4.webp";